import script from "./PhotoCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoCapture.vue?vue&type=script&setup=true&lang=js"

import "./PhotoCapture.vue?vue&type=style&index=0&id=f6307a34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6307a34"]])

export default __exports__